export const ORDER_TYPES = {
  NOTA_FISCAL: 'N',
  PEDIDO: 'P',
  MKT_SAC: 'A',
  VENDA_FUTURA: 'M',
  HOMECENTER: 'H',
  BONIFICACAO: 'B',
}

export const ORDER_TYPES_LABELS = {
  N: 'NOTA FISCAL',
  P: 'PEDIDO',
  M: 'VENDA FUTURA',
  B: 'BONIFICAÇÃO',
  H: 'HOME CENTER',
  A: 'MKT SAC',
}

export const ORDER_TYPES_ACRONYM = {
  N: 'NF',
  P: 'PE',
  A: 'MKT/SAC',
  M: 'VF',
  B: 'BN',
  H: 'HC',
}

// ----------------------------------------------------------

export const isSelectableOrderItem = (type) =>
  [ORDER_TYPES.VENDA_FUTURA].includes(type)

export const isEditableOrderItem = (type) =>
  [ORDER_TYPES.VENDA_FUTURA].includes(type)
